import { object, string } from "yup";
import { CEM, CENTOCINQUENTA, DOIS } from "@/utils/constants";

const embaixadorPessoaSchema = object({
  nome: string()
    .required()
    .min(DOIS, "Nome deve ter pelo menos 2 caracteres")
    .max(CEM, "Nome deve ter no máximo 100 caracteres")
    .default("")
    .label("Nome"),

  telefone: string()
    .required()
    .matches(/^(\+55\s?)?(\(?\d{2}\)?\s?)?\d{4,5}-?\d{4}$/, "Telefone deve ter formato válido (ex: (11) 99999-9999)")
    .default("")
    .label("Telefone"),

  email: string()
    .required()
    .email("Email deve ter formato válido")
    .max(CENTOCINQUENTA, "Email deve ter no máximo 150 caracteres")
    .default("")
    .label("Email")
});

export default embaixadorPessoaSchema;
